import { Component, Input, OnInit } from '@angular/core';

import { PayRateSetModel } from '@bayclubs/group-classes-employee-api';

import { InstructorsApiService } from '../../../shared/services/instructors.api.service';



@Component({
    selector: 'app-provider-current-payrates',
    templateUrl: './provider-current-payrates.component.html',
    styleUrls: ['./provider-current-payrates.component.scss'],
    standalone: false
})
export class ProviderCurrentPayratesComponent implements OnInit {
    @Input() providerId: string;

    @Input() payRates: PayRateSetModel;

    constructor(private instructors: InstructorsApiService) {}

    ngOnInit() {
        if (!this.payRates && this.providerId) {
            this.instructors.getCurrentPayRates(this.providerId).subscribe(data => {
                this.payRates = data;
            });
        }
    }
}
